// Show all button of a merchant
jQuery(document).ready(function ($) {
    $('.listicle-group__view-all-button').click(function (event) {
        

        // Toggle all the .listicle-item--hide of the current .listicle-group
        $(this).parents('.listicle-group__content').find('.listicle-item--extras').toggleClass('listicle-item--hide');
        // Toggle button text
        if ($(this).text() === "Show All Outlets") {
            $(this).text("Hide Outlets");
        } else {
            $(this).text("Show All Outlets");
        }
        event.preventDefault(); // Prevent the default action of the anchor link
        return false;
    });

    // Disable if having less than 3
    $('.listicle-group').each(function (i) {
        let extraItems = $(this).find('.listicle-item--extras').length;
        if (extraItems <= 0 ) {
            $(this).find('.listicle-group__view-all-button').hide();
        }
    });
});
